import classNames from "classnames";
import React from "react";
import styles from "./GeneralInputWrapper.module.scss";
import { WuiltContext } from "@/shared/types";
interface GeneralInputWrapperProps {
  children: React.ReactNode;
  isError?: boolean;
  wuiltContext?: WuiltContext;
}

const GeneralInputWrapper: React.FC<GeneralInputWrapperProps> = ({
  children,
  isError,
}) => {
  return (
    <div
      id="general-text"
      className={classNames("general-input-wrapper-view", {
        [styles.generalInputWrapper]: true,
        [styles.error]: isError,
      })}
    >
      {children}
    </div>
  );
};

export default GeneralInputWrapper;
